module.exports = __webpack_public_path__ + "static/media/login-avatar.790a2b1b.svg";